export default __webpack_public_path__ + "static/assets/med_pill_round_in_L1_solid_x_01_f_mask.0923fe1d.png";